// src/js/reducers/index.js
import * as types from "../constants/action-types";

export default function picopReducer(state = [], action) {
    switch (action.type) {

        case types.LOGOUT:
            return []
        case types.CREATE_PICOP_SUCCESS:
            return [...state, Object.assign({}, action.picop)];
        case types.UPDATE_PICOP_SUCCESS:
            return [...state.filter(picop => picop.picopId != action.picop.picopId), Object.assign({}, action.picop)];
        case types.GET_PICOP_SUCCESS:
            return [...state.filter(picop => picop.picopId != action.picop.picopId), Object.assign({}, action.picop)];
        case types.DELETE_PICOP_SUCCESS:
            return [...state.filter(picop => picop.picopId != action.picop.picopId)];      
        case types.LOAD_PICOP_SUCCESS:
            return action.picops;
        
        default:
            return state;
    };
};

